import text from './text'
import * as api from "./api";
import * as utils from './utils'
import * as interaction from './interaction.js';
import $ from "jquery";
import language from './language';
//引入图片 3个
import "../img/share-zh.jpg";
import "../img/share-vi.jpg";
import "../img/share-thai.jpg";

const getLoginStatus = isClean => {
	return new Promise(resolve => {
		FB.getLoginStatus(response => {
			resolve(response.status === "connected");
		}, isClean);
	});
};

const fbLogin = () => {
	return new Promise(resolve => {
		FB.login(function (response) {
			resolve(response.status === "connected");
		});
	});
};

const getFbUserInfo = function () {
	return new Promise(resolve => {
		FB.api("/me", function (res) {
			resolve({ fb_id: res.id, fb_name: res.name });
		});
	});
};

const excShare = info => {
	return new Promise(resolve => {
		FB.ui(info, function (res) {
			resolve(res && !res.error_message);
		});
	});
};

export const share = async () => {
    const pageLanguage = language.getLang();
	// const message = text[pageLanguage].shareMessage;
	const message = language.getText("shareMessage");
	const title = language.getText("shareTitle");
	const imgname = "share-" + pageLanguage;
	let picUrl = `https://gevents.37games.com/dlssrvtyy/img/${imgname}.jpg`;
	if (pageLanguage === "vi") {
		picUrl = `https://gevents.endomainname.com/dlssrvtyy/img/${imgname}.jpg`;
	}
	
	let userInfo = { fb_id: "", fb_name: "" };
	
	let shareUrl = `https://gevents.37games.com/dlssrvtyy/index.html?cid=share&scid=fb`;
	let info = {
		display:"popup",
		method: "share",
		href: `https://geventsapi.37games.com/fbShareCustomize/customizeShare/message/${message}/app_id/924584694817603/share_title/${title}/redict_url/${encodeURIComponent(
			shareUrl
		)}/pic_url/${encodeURIComponent(picUrl)}`,
	};
	if (utils.isFBAndroid()) {
		info.href = encodeURIComponent(info.href);
	}
	if (utils.deviceType() != 'android') {
		let checkRes = await getLoginStatus();
		if (!checkRes) {
			await fbLogin();
		}
		let shareRes = await excShare(info);
		userInfo = await getFbUserInfo();
		if (!shareRes) {
			// tips.alert("shareFail");
			return;
		}
	} else {
		excShare(info);
		// userInfo = await getFbUserInfo();
	}
	// if (language.getLang()=="vi") {
	// 	window.open("https://www.facebook.com/DauLaDaiLuc3D.VN/");
	// } else {
		
	// }
	// if (language.getLang()=="thai") {
	// 	window.open("https://www.facebook.com/DouLuoDalu3D.TH/");
	// } else {
	// 	window.open("https://www.facebook.com/DauLaDaiLuc3D.VN/");
	// }
	
  try {
        const informationForm = {
      		phone_merge: localStorage.getItem('phone_merge'),
      		email: localStorage.getItem('email'),
        };
		const { code, result, data, msg } = await api.req('shareCallback',informationForm);
		if (parseInt(result) === 1) {
			if (code == "20002") {
			//已分享
				$(".j-popup-main").html(language.getText("popupTip2"));
				interaction.popup.showPopup('common-tip');
				return;
			}
			//分享成功
			$(".j-popup-main").html("");
    		$(".j-popup-message").html("");
			interaction.popup.showPopup("share");
			data && $('.j-remain-num').text(data.lottery_chance);
        	$('.j-fb-share').removeClass('zan');
		} else {
		// tips.alert("shareFail");
		}
	} catch (e) {
	  if (e.code == "-20013") {
			$(".j-popup-main").html(language.getText("timeEnd"));
			interaction.popup.showPopup('common-tip');
			return;
		}
	}
};
